export default __webpack_public_path__ + "static/media/KOD0147-min.30737025.webp";